import W2PContentManagement from 'components/MapoAdministration/components/Content-Management/W2PContentManagement';

const ScreenW2PContentManagement = () => {
  return <W2PContentManagement />;
};

export default ScreenW2PContentManagement;
